import SubmissionsButton from "../pages/MOC/components/SubmissionsButton";

const MOCCustomComponents = {
  SubmissionsButton,
};

export default MOCCustomComponents;
